export enum FeatureID {
    discoveryConsultantQuestionsVideos = 'discovery_consultant_questions_videos_12d29b158380',
    moovsForSelf = 'moovs_for_self_c1654b0c882d',
    driverMoovsForTeam = 'driver_moovs_for_team_def4f45a66a5',
    emergancyMoovsForTeam = 'emergancy_moovs_for_team_6db239914228',
    engagementMoovsForTeam = 'engagement_moovs_for_team_6f24e83bba62',
    llmChat = 'llm_chat_aa17ed4aefbd',
    stateViewDashboard = 'state_view_dashboard_4ad82bb820e3',
    teamView = 'team_view_5f94c7200f37',
    chatAudioTTS = 'chat_view_audio_tts_cc32b11bd3b6',
    chatManagePeopleOfInterest = 'chat_view_manage_people_of_interest_63ad9db4d107',
    auth0_msft = 'auth0_msft_18c5b0655745',
    structuredProcess = 'structured_process_12d29b158380'

}